// Fotos de los niveles del programa de distribuidoras, en orden de monto
// (nivel 1 = el más bajo). Se usan en el masonry del panel de socia y como
// miniatura de los regalos en el carrito.
export const DISTRIBUTOR_TIER_IMAGES = [
  '/images/secciones/Socios/Bienvenida_socia.webp',
  '/images/secciones/Socios/Cuidado_completo.webp',
  '/images/secciones/Socios/Ritual_signature.webp',
  '/images/secciones/Socios/proximamente_1.webp',
  '/images/secciones/Socios/Proximamente_2.webp',
];
